// extracted by mini-css-extract-plugin
export default {"SubscriptionPreside":"SubscriptionPreside--H5fcM","row-top":"row-top--FEZfz","row-bottom":"row-bottom--7CHcr","bottom-text":"bottom-text--vRrwu","bottom-btn":"bottom-btn--edWkn"};